import axios from "axios";

export const cmsInstance = axios.create({
  baseURL: `https://tlg-hotels-backend-ln3d7hlutq-uc.a.run.app`,
  // baseURL: "http://localhost:8080",
});
